import { useEffect, useRef, useState } from 'react'
import SearchIcon from './icon'
import { navigate } from 'gatsby'
import { useShopStoreIncontext } from '../../../context/shopContext'

const urlLookup = {
  en: '/us/search',
  'en-AU': '/au/search',
  'en-NZ': '/nz/search',
  'en-GB': '/uk/search',
  'en-CA': '/ca/search',
}

const SearchBar = ({ white }) => {
  const storeLocale = useShopStoreIncontext((state) => state.storeLocale)
  const [searchOpen, setSearchOpen] = useState(false)
  const [hideBackground, setHideBackground] = useState(false)
  const inputRef = useRef()

  useEffect(() => {
    if (searchOpen) {
      setHideBackground(searchOpen)
      inputRef.current.focus()
    } else {
      setTimeout(() => {
        setHideBackground(searchOpen)
      }, 200)
    }
  }, [searchOpen])

  const handleSubmitSearch = () => {
    const toReplace = 'https://test.com'

    const url = urlLookup[storeLocale]
    const urlObject = new URL(`${toReplace}${url}`)
    urlObject.searchParams.set('q', inputRef.current.value)

    navigate(urlObject.toString().replace(toReplace, ''))
    setSearchOpen(false)
    inputRef.current.value = ''
  }

  const onSubmit = (e) => {
    e.preventDefault()
    handleSubmitSearch()
  }

  const handleSearchIconPress = () => {
    if (
      searchOpen &&
      !(
        inputRef.current.value === '' ||
        inputRef.current.value === null ||
        inputRef.current.value === undefined
      )
    ) {
      handleSubmitSearch()
    } else {
      setSearchOpen((prev) => !prev)
    }
  }

  return (
    <div
      className="flex-row, flex overflow-hidden rounded-full px-4 py-2 transition"
      style={{ ...(hideBackground && { background: '#F7F6F4' }) }}
    >
      <form onSubmit={onSubmit}>
        <div
          className="overflow-hidden"
          style={{
            ...(!searchOpen ? { maxWidth: 0 } : { maxWidth: 180 }),
            transition: 'max-width 0.2s ease-in-out',
          }}
        >
          <input
            ref={inputRef}
            style={{
              background: '#F7F6F4',
              outline: '#000',
              width: '100%',
              marginTop: 2,
            }}
            type="text"
            placeholder="Search..."
          />
        </div>
      </form>
      <SearchIcon
        white={white && !searchOpen}
        onClick={handleSearchIconPress}
      />
    </div>
  );
}

export default SearchBar
